export const TableDestinationTitle = [
    { label: 'ລຳດັບ' },
    { label: 'ລາວ' },
    { label: 'ອັງກິດ' },
    { label: 'ຄຳອະທິບາຍ' },
    { label: 'ການຈັດການ' },
];